import Auth from "@aws-amplify/auth";
import { useNavigation } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import React, { useCallback } from "react";
import { View } from "react-native";
import { Icon, Text } from "react-native-elements";
import { useRecoilCallback, useRecoilValue } from "recoil";
import { RootStackParamList } from "../../App";
import { appContextState, selfGuidedTourSelectedState } from "../client";
import { mobileModeState } from "../state/mobileMode";
import { colors, fonts, FONT_SIZE_SECONDARY, UNIT } from "../styles";
import { DEMO_EMAIL } from "../useDemoMode";

const styles = {
  header: {
    backgroundColor: colors.neutral900,
    height: 64,
    paddingRight: UNIT * 4,
    paddingLeft: UNIT * 2,
    flexDirection: "row",
  } as const,
  beta: {
    fontSize: 16,
    lineHeight: 18,
    height: UNIT * 2,
    top: UNIT * 1.5,
    left: -UNIT * 3,
    paddingLeft: UNIT,
    paddingRight: UNIT,
    transform: [{ rotate: "30deg" }],
    fontFamily: fonts.smallHeader,
    color: "white",
    backgroundColor: colors.green,
    borderRadius: UNIT / 2,
    shadowOffset: { width: 2, height: 5 },
    shadowColor: "#000",
    shadowOpacity: 0.1,
  },
  brand: {
    top: 11,
    lineHeight: 48,
    fontSize: 40,
    color: "white",
    fontFamily: fonts.header,
  },
  email: {
    height: 20,
    marginTop: UNIT * 2,
    textAlign: "right",
    alignSelf: "flex-end",
    color: "white",
  } as const,
  logout: {
    height: 16,
    fontSize: FONT_SIZE_SECONDARY,
    paddingBottom: 16,
    textAlign: "right",
    alignSelf: "flex-end",
    color: "#cccccc",
  } as const,
  hidden: {
    display: "none",
  },
  logoImageStyle: {
    marginTop: 8,
    width: UNIT * 6,
    height: UNIT * 6,
    marginRight: UNIT,
  } as const,
};

const emailToText = (email: string) => {
  if (email === DEMO_EMAIL) return "Self Guided Tour";
  return email;
};

type HeaderProps = {
  hideAuthState?: boolean;
  onToggleMenu?: () => void;
};

export default function Header(props: HeaderProps) {
  const navigation = useNavigation<StackNavigationProp<RootStackParamList>>();
  const appContext = useRecoilValue(appContextState);
  const mobileMode = useRecoilValue(mobileModeState);

  const logout = useRecoilCallback(({ set }) => () => {
    set(selfGuidedTourSelectedState, false);
    Auth.signOut();
  });

  const profileStyle = props.hideAuthState ? styles.hidden : {};

  const home = useCallback(() => {
    navigation.navigate("Persona");
  }, [navigation]);

  return (
    <View style={styles.header}>
      {mobileMode ? (
        <Icon
          name="menu"
          type="feather"
          color="white"
          size={36}
          onPress={props.onToggleMenu}
          containerStyle={{ marginTop: 13, marginRight: UNIT * 2 }}
        />
      ) : null}

      {/* <Image
        source={require("../../logo-design.png")}
        style={styles.logoImageStyle}
      /> */}
      <Text style={styles.brand} onPress={home}>
        BomData
      </Text>
      <Text style={styles.beta} onPress={home}>
        beta
      </Text>
      {!mobileMode && appContext && (
        <>
          <View style={{ flex: 1 }}></View>
          <View style={profileStyle}>
            <Text style={styles.email}>{emailToText(appContext.email)}</Text>
            <Text style={styles.logout} onPress={logout}>
              Log Out
            </Text>
          </View>
        </>
      )}
    </View>
  );
}
